import { render } from "./Offer.vue?vue&type=template&id=5e45fcd2"
import script from "./Offer.vue?vue&type=script&lang=js"
export * from "./Offer.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/cafepayam-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__